import { render } from "./Google.svg?vue&type=template&id=1823d9c3"
const script = {}
script.render = render

export default script